module.exports = __webpack_public_path__ + "media/images/covid/covid-header_org-9138b43a52261936100a4f3dc85b1f52.jpg";